import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

/**
 * StructuredData - JSON-LD structured data for SEO
 * Works with react-snap for pre-rendering
 */
export const StructuredData = ({ title, description, url, type = 'WebPage' }) => {
    const location = useLocation();
    // SSR-safe base URL (works with react-snap pre-rendering)
    // react-snap runs in Node.js, so window is undefined during pre-rendering
    const getBaseUrl = () => {
        if (process.env.REACT_APP_FE_URL) return process.env.REACT_APP_FE_URL;
        if (typeof window !== 'undefined') return window.location.origin;
        return ''; // Fallback for react-snap (will use config URLs)
    };
    const siteUrl = getBaseUrl();
    const currentUrl = url || `${siteUrl}${location.pathname}`;

    // WebPage Schema
    const webPageSchema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": currentUrl,
        "url": currentUrl,
        "name": title,
        "description": description,
        "inLanguage": "en-AE",
        "isPartOf": {
            "@type": "WebSite",
            "@id": `${siteUrl}/#website`,
            "name": "DGTIA Tools",
            "url": siteUrl,
            "publisher": {
                "@type": "Organization",
                "@id": `${siteUrl}/#organization`,
                "name": "DGTIA",
                "url": "https://dgtia.com",
                "logo": {
                    "@type": "ImageObject",
                    "url": `${siteUrl}/images/logo.svg`
                },
                "sameAs": [
                    "https://linkedin.com/company/dgtia",
                    "https://facebook.com/dgtia",
                    "https://twitter.com/dgtiaofficial",
                    "https://instagram.com/thedgtia"
                ]
            }
        }
    };

    // Organization Schema
    const organizationSchema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "@id": `${siteUrl}/#organization`,
        "name": "DGTIA",
        "alternateName": "DGTIA Tools",
        "url": "https://dgtia.com",
        "logo": {
            "@type": "ImageObject",
            "url": `${siteUrl}/images/logo.svg`
        },
        "sameAs": [
            "https://linkedin.com/company/dgtia",
            "https://facebook.com/dgtia",
            "https://twitter.com/dgtiaofficial",
            "https://instagram.com/thedgtia"
        ]
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(webPageSchema)}
            </script>
            <script type="application/ld+json">
                {JSON.stringify(organizationSchema)}
            </script>
        </Helmet>
    );
};

